// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__OIK3c","buttons":"Footer_buttons__2QVp-"};